import { jsx as _jsx } from "react/jsx-runtime";
export function SharedTableBody(props) {
    const { data, visibleColumns, adjustedColumns, bodyClassName, rowBodyClassName, gridTemplateColumns, onRowClick, isRowSelected, } = props;
    return (_jsx("div", { className: bodyClassName, children: data.map((item) => {
            const selected = isRowSelected?.(item) || false;
            const isLate = item.late > 0;
            // Собираем классы для строки
            const rowClassName = [
                rowBodyClassName,
                isLate ? `${rowBodyClassName}--late` : "",
                selected ? `${rowBodyClassName}--selected` : "",
            ]
                .filter(Boolean)
                .join(" ");
            return (_jsx("div", { style: {
                    display: "grid",
                    gridTemplateColumns: gridTemplateColumns,
                }, className: rowClassName, onClick: () => onRowClick?.(item), children: visibleColumns.map((colId) => {
                    const col = adjustedColumns[colId];
                    if (!col)
                        return null;
                    return (_jsx("div", { className: col.className, children: col.renderCell
                            ? col.renderCell(item)
                            : `Cell ${colId} - ${item.key}` }, colId));
                }) }, item.key));
        }) }));
}
